<article class="narrow-page">
  <header class="banner" id="main-content-focus" tabindex="-1">
    <div class="layout-grid" id="aria_page_header">
      <h1>This page didn't load</h1>
    </div>
  </header>

  <div class="layout-grid narrow-page__content">
    <p>Something went wrong while getting it. Check your connection, then try again.</p>

    <div class="load-error-view__actions">
      <button matButton="filled" type="button" (click)="onClick_retry()">Try again</button>
      <a matButton routerLink="/">Go to the home page</a>
    </div>
  </div>
</article>
